module.exports = __webpack_public_path__ + "media/images/icons/icon_college-0cb23c90bd3f04ae8fa54dff90e0a8d8.png";